import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SITE } from "@/data/site";

const COLUMNS = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/features" },
      { label: "How it works", to: "/#how-it-works" },
      { label: "FAQ", to: "/#faq" },
      { label: "Download", to: "/#download" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "Help Center", to: "/help" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
      { label: "Cookie Policy", to: "/cookies" },
      { label: "Data Deletion", to: "/data-deletion" },
      { label: "Delete Account", to: "/delete-account" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-indigo-deep text-sand">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-5 md:gap-12">
          <div className="col-span-2">
            <Logo textClass="text-sand" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-sand/70">
              {SITE.tagline}. One app to keep your family connected, healthy and protected.
            </p>
            <a
              href={`mailto:${SITE.supportEmail}`}
              data-testid="footer-support-email"
              className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-sand transition-colors hover:text-marigold"
            >
              <Mail className="h-4 w-4 text-marigold" />
              {SITE.supportEmail}
            </a>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-sand">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-sand/70 transition-colors hover:text-marigold"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-sm text-sand/60">
            © {new Date().getFullYear()} {SITE.name}. All rights reserved.
          </p>
          <p className="text-xs text-sand/50">
            Kinect Nova AI is a wellness and coordination tool and does not replace professional medical advice or emergency services.
          </p>
        </div>
      </div>
    </footer>
  );
}
